
import '../music.css';
import { Form, Input, InputNumber, Button, Layout, Row, Col,Upload,notification, message,Modal, Checkbox, Select,ConfigProvider, Divider, Collapse, Card, Menu    } from 'antd';
import React, { Component, Fragment } from "react";
import cabezal from '../static/img/Cabezal_Music.jpg'



import { CountryDropdown, RegionDropdown, CountryRegionData } from 'react-country-region-selector';
import { UploadOutlined,CheckOutlined, HomeOutlined,FileTextOutlined, MinusCircleOutlined, EyeInvisibleOutlined, EyeTwoTone, LockOutlined,MailOutlined, UserOutlined, LogoutOutlined} from '@ant-design/icons';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import axios from "axios";
import validator from 'validator';
import es_ES from 'antd/lib/locale/es_ES';
import countries from '../static/json/countries.json'
import {NavLink} from "react-router-dom";
import Navbar from '../components/NavBar';

class App extends Component {
  constructor(props){
    super(props)
    this.state={
      phone: '',
      sended: false,
      showRegistrate: false,
      genres:[],
      fileList: [],
      authors:[],
    }
    // const promise = axios.get('https://back.premiocasa.cult.cu/api/musica/genero/')
    // const dataPromise = promise.then((response)=> response.data)
    // console.log(dataPromise)
  }

  async componentDidMount() {
    const response = await fetch('https://back.premiocasa.cult.cu/api/musica/genero/');
    const json = await response.json();
    if(json['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    this.setState({ genres: json });
  }

  addAuthor = () =>{

  }

  render() {
    
    const layout = {
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },

    }
    const centerStyle = {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      marginLeft:'203px'
    };

    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          offset: 1,
        },
        sm: {
          span: 4,
          offset: 8,
        },
      },
    };
    
    const validateMessages = {
      required: '${label} es requerido!',
      types: {
        email: '${label} no es un email válido!',
        number: '${label} no es un número válido!',
      },
      number: {
        range: '${label} must be between ${min} and ${max}',
      },
    }

    function addAuthors(formdata, users, name) {
      for (var i = 0; i < users.length; i++) {
        addSingleAuthor(formdata, users[i], name + "[" + i + "]");
      }
  }
  
  function addSingleAuthor(formdata, user, name) {
      for (var key in user) {
          formdata.append(name + "." + key,  user[key]);
      }
  }
      
    const customRequest = (form) => {
     
      const data= new FormData()
      console.log(form)
      for(var aut in  form['autores']){
        form['autores'][aut]['tel'] = '+' + form['autores'][aut]['tel']
        console.log(form['autores'][aut]['tel'])

      }

    //   form
    //   console.log(form['pdf'].fileList[0])
      form['pdf'] =  form['pdf'].fileList[0]["originFileObj"]
      for ( var key in form ) {
        if(key =='autores'){
          data.append(key,JSON.stringify( form[key]));
          // addAuthors(data,form[key],'autores')
        }
        else{
          data.append(key, form[key]);
        }
    }

  //   for (var value of data.values()) {
  //     console.log(value);
  //  }
      axios.post('https://back.premiocasa.cult.cu/api/PremioCasa2022/obra/register/', data).then((res) => {
        if (res.status == 200){
          Modal.success({
            content: 'Gracias por registrarse en el concurso',
          });
        } ;
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise sus datos',
        });
      })
  }
    
    const checkBoxChange = e =>{
      console.log(e.target.checked)
      this.setState({showRegistrate:e.target.checked})
    }
    const handlesubmit = (values) =>{
      console.log(values)
        axios.post(
          'https://back.premiocasa.cult.cu/api/musica/obra/',{
          data:values
        }).then((res) => {
          console.log(res)
              if (res.status == 200) {
                notification.success("data successfully updated!");
              }
              else{
                notification.error({
                  message:'Error',
                  description:'Ter was an error',
                  
                });
              }
            })
            .catch((err) => {
              
              console.log(err)
            });
    }
      const onFinish = (values) => {
        console.log(values);
      }
      const { Header, Footer, Content } = Layout;
      const { Option } = Select;
      const { fileList } = this.state;
      const props = {
        onRemove: file => {
          this.setState(state => {
            const index = this.state.fileList.indexOf(file);
            const newFileList = state.fileList.slice();
            newFileList.splice(index, 1);
            return {
              fileList: newFileList,
            };
          });
        },
        beforeUpload: file => {
          this.setState({
            fileList: [file],
          });
          return false;
        },
        fileList,
      };
      const { Panel } = Collapse;
      const autores = <div>
          </div>

const menu = (
  <Menu style={{height:'140'}} mode="inline">
        <Menu.Item key="home" icon={<HomeOutlined style={{ fontSize: '26px'}}/>} >
          <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/musicologia/admin"> Home</NavLink>
        </Menu.Item>
        <Menu.Item key="plays" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
          <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/musicologia/admin_plays_list"> Obras</NavLink>
        </Menu.Item>
        <Menu.Item key="conc" icon={<UserOutlined style={{ fontSize: '26px'}} />}>
          <NavLink style={{fontSize:'20px', fontWeight:'bold'}} to='/musicologia/admin_conc_list'> Concursantes  </NavLink>
        </Menu.Item>  
  <Menu.Item key="logout" icon={<LogoutOutlined style={{ fontSize: '26px'}} />}  >
  <a onClick={this.logout}style={{fontSize:'20px', fontWeight:'bold'}}> Cerrar sesión </a>
  </Menu.Item>
  
  </Menu>
)
    return (

      <div className="page-container">
        <div className = "content-wrap">
        <ConfigProvider locale={es_ES}>
        <Layout style={{backgroundColor:'white'}}>
<Row>
            <Col><NavLink to="/musicologia/admin"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
          </Row>
          <Row>
            <Col span={24}>
              <Navbar menu = {menu}/>
            
            </Col>
          </Row>
          <div style={{flexDirection:'column', flex:'1 0 auto', display:'flex'}} >
          
         
          <Row >
            <Col span={24} >
            <Content style={{ padding: '0 50px' }}>
            <Card title=" Pol&iacute;ticas, t&eacute;rminos y condiciones para participantes y jurados en la Convocatoria Web al Premio Casa" bordered={false}  >
         
         <p>Casa de las Am&eacute;ricas, proporciona una plataforma en l&iacute;nea creando facilidades de comunicaci&oacute;n, acceso a convocatorias, env&iacute;o de obras concursantes, consultas, seguridad y garant&iacute;as para la continuidad de las sucesivas ediciones del Premio Casa.</p>
         <p>Objetivo. Con la aceptaci&oacute;n de esta Pol&iacute;tica, los t&eacute;rminos y condiciones en ella expresados, usted est&aacute; aceptando reglas y principios relacionados con el procesamiento de datos que se aplicar&aacute;n a los concursantes y jurados en las Convocatorias al Premio Casa que, en lo adelante, se promuevan.</p>
         <p>Usted puede acceder a la p&aacute;gina <a  target="_blank" href="https://premiocasa.cu">https://premiocasa.cu</a>. Y, una vez aceptadas las pol&iacute;ticas, inscribirse como concursante cumpliendo los requisitos y aportando la informaci&oacute;n que la p&aacute;gina le va demandando.</p>
         <p>I. Est&aacute;ndares de Participaci&oacute;n.</p>
         <p>Si se ha inscrito como concursante est&aacute; aceptando,</p>
         <ol>
         <li>Que la(s) obra(s) que carga en el sitio se considerar&aacute;n obra(s) en concurso, garantizando que es el autor de todo su contenido, que cumple con los formatos y requisitos de la convocatoria y que autoriza a Casa de las Am&eacute;ricas a reenviar los archivos a todos los miembros del jurado.</li>
         <li>&nbsp;Que no infringe ning&uacute;n derecho de propiedad intelectual, y que libera a Casa de las Am&eacute;ricas de cualquier reclamaci&oacute;n de terceros que tenga relaci&oacute;n con el derecho de autor o los derechos de intimidad y protecci&oacute;n de datos.</li>
         <li>&nbsp;&nbsp;Que, una vez cargada(s) la obra(s) en el sitio, no podr&aacute; realizar personalmente ninguna modificaci&oacute;n. Para registrar&nbsp; cambios o cancelaciones debe dirigir su solicitud al email  dirmusica@casa.cult.cu. &nbsp;</li>
         <li>Que la(s) obra(s) que presente a concurso, estar&aacute;n identificadas con el nombre del autor o seud&oacute;nimo. Los datos personales que incluya en su inscripci&oacute;n no ser&aacute;n de dominio del jurado y s&oacute;lo tendr&aacute; acceso a esos datos personas autorizadas con niveles de acceso y contrase&ntilde;as individuales.</li>
         <li>Que autoriza a Casa de las Am&eacute;ricas a administrar sus datos personales, as&iacute; como toda la informaci&oacute;n que de la(s) obra(s) concursante(s) env&iacute;e, para los fines del concurso y con los l&iacute;mites establecidos en la Convocatoria.</li>
         <li>Que usted ha aceptado los t&eacute;rminos de la Convocatoria &iacute;ntegramente.</li>
         </ol>
         <p>Si ha sido seleccionado como jurado y da su consentimiento, est&aacute; aceptando:</p>
         <ol>
         <li>Que recibir&aacute; las obras en concurso que sean puestas a su disposici&oacute;n en la p&aacute;gina <a href="">https://premiocasa.cu/jurados</a> identific&aacute;ndose con la contrase&ntilde;a que le sea suministrada por los administradores.</li>
         <li>Que ser&aacute; depositario de esas obras y se abstendr&aacute; de utilizar las mismas para fines distintos o ajenos al concurso, quedando prohibida su comunicaci&oacute;n p&uacute;blica y cualquier acto de divulgaci&oacute;n de todo o parte de las mismas, con excepci&oacute;n de los intercambios entre los miembros del jurado con los que participe.</li>
         <li>Que mantendr&aacute; total confidencialidad sobre los datos a los que tenga acceso por raz&oacute;n del concurso, as&iacute; como sobre las discusiones que en relaci&oacute;n con las obras se suscite.</li>
         <li>Que una vez concluidas las deliberaciones y emitida el Acta del jurado, destruir&aacute; los archivos y datos sobre los autores que haya recibido para la realizaci&oacute;n de este encargo.</li>
         </ol>
         <p>Casa de las Am&eacute;ricas se compromete a:</p>
         <ol>
         <li>Proteger la integridad de las obras depositadas antes y durante el concurso.</li>
         <li>Destruir los archivos una vez entregados los premios, exceptuando las obras galardonadas que ser&aacute;n conservadas y protegidas.</li>
         <li>En caso de obras no premiadas, que hayan sido recomendadas por el jurado o sean de inter&eacute;s para la Casa, se conservar&aacute;n y proteger&aacute;n, previa comunicaci&oacute;n con sus autores.</li>
         <li>Compartir las obras concursantes s&oacute;lo con los jurados que correspondan en cada caso.</li>
         <li>Tratar con total confidencialidad los datos personales de los autores y darlos a conocer p&uacute;blicamente solo en caso de ser galardonados.</li>
         <li>Incorporar al directorio de la Casa, los datos personales de los participantes s&oacute;lo para el env&iacute;o de informaciones y comunicaci&oacute;n institucional, salvo que el concursante disponga expresamente lo contrario.</li>
         </ol>
         <p>10. Usar, procesar, trasmitir y almacenar la informaci&oacute;n que reciba en raz&oacute;n del concurso bajo los principios de legalidad, propiedad y necesidad.</p>
         <p>11. Los archivos que contengan las obras e informaciones del concurso ser&aacute;n custodiados, protegidos y administrados por el &aacute;rea de Inform&aacute;tica de la Casa de las Am&eacute;ricas y tendr&aacute;n acceso s&oacute;lo los organizadores del Premio Casa.</p>
                     
                  </Card>
          </Content>
              
              </Col>
          </Row>
   </div>
          
         


          </Layout>
        </ConfigProvider>
        </div>
        <div >
          <Footer style={{backgroundColor:'#ed7e8e', position:'relative',bottom:'0px',left:'0px',right:'0px',flexShrink:0}}>
          
          <Row justify="center" align="middle" style={{ width:'100%', backgroundColor:'#ed7e8e',  marginBottom:'0px', bottom:'0px'}}>
          <Col xl={6} xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}>  <NavLink to="/musicologia/admin_bases" style={{color:'white'}}>Bases del concurso</NavLink></div></Col>
          <Col  xl={4}xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}><a style={{color:'white'}} href = "mailto:  dirmusica@casa.cult.cu"> dirmusica@casa.cult.cu</a></div></Col>
          <Col  xl={{span:4, offset:2}} sm={{span:6}} xs={{span:24}} ><div style={{textAlign: 'center'}}><a style={{color:'white', textAlign: 'center'}} target="_blank" href="http://www.casadelasamericas.org/"> Sitio Oficial Casa de las Américas</a> </div></Col>
          <Col xl={4}xs={24}sm={{span:6}} ><div style={{textAlign: 'center'}}><a style={{color:'white'}}target="_blank"  href="http://laventana.casa.cult.cu/"> La Ventana</a></div></Col>
          <Col  xl={4} xs={24} sm={{span:24}}><div style={{textAlign: 'center'}}> <NavLink to="/musicologia/admin_terminos" style={{color:'white'}}>Términos y condiciones de uso</NavLink></div></Col>
          
        </Row>
        </Footer>
        </div>
    </div>

    );
  }
}
export default App;


